import { render, staticRenderFns } from "./ATemplateContratoMaes.vue?vue&type=template&id=35afa4c2"
import script from "./ATemplateContratoMaes.vue?vue&type=script&lang=js"
export * from "./ATemplateContratoMaes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports